import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { hideCookiesWarning } from '../../redux/logged/actions';
import Image from '../Image';

const Container = styled.div`
  ${({ theme }) => css`
    width: calc(100% + 48px);
    padding: 20px;
    padding-left: 24px;
    background-color: ${theme.colors.bbrand200};
    color: ${theme.colors.bbrand700};
    margin: 5px -24px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    ${theme.breakpoint('md')} {
      border-radius: 6px;
      max-width: 750px;
      align-self: center;
      padding: 17px 24px 17px 27px;
    }
  `}
`;
const ImageContainer = styled.div`
  width: 15.5px;
  margin-right: 17px;
  flex-shrink: 0;
  img {
    width: 100%;
  }
  ${({ theme }) => theme.breakpoint('md')} {
    width: 21.7px;
    height: 21.7px;
    margin-right: 18.3px;
  }
`;
const Text = styled.div`
  ${({ theme }) => css`
    ${theme.textTypes['Caption-w500']}
    margin-right: 29px;
    ${theme.breakpoint('md')} {
      ${theme.textTypes['Body-2-w500']}
    }
  `}
`;
const CloseIcon = styled.div`
  width: 18px;
  flex-shrink: 0;
  margin-left: auto;
  cursor: pointer;
  img {
    width: 100%;
  }
  ${({ theme }) => theme.breakpoint('md')} {
    width: 24px;
    height: 24px;
  }
`;

export default ({ className }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const closeWarning = useCallback(() => dispatch(hideCookiesWarning()), [dispatch]);

  const open = useSelector((state) => state.logged.showCookiesWarning);

  return (
    <>
      {open && (
        <Container className={className}>
          <ImageContainer>
            <Image src="cookie.svg" />
          </ImageContainer>
          <Text>{t('Onboarding.common.cookies')}</Text>
          <CloseIcon onClick={closeWarning}>
            <Image src="close-warnin-blue.svg" />
          </CloseIcon>
        </Container>
      )}
    </>
  );
};
